/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client'
import { RoleType, UserRole } from '../../../authProvider'

type UserInfoResponse = {
  id: number
  admin: boolean
  fullName: string
  email: string
  publishers: UserRole[]
  vendors: UserRole[]
  affiliates: UserRole[]
}

export const QUERY = gql`
  query {
    viewer {
      ... on OrgUser {
        databaseId
        firstName
        lastName
        email
        admin
        publishers(first: 2) {
          nodes {
            databaseId
            name
            hostname
            organization {
              databaseId
            }
          }
        }
        vendors(first: 2) {
          nodes {
            databaseId
            name
            company
            organization {
              databaseId
            }
          }
        }
        affiliates(first: 2) {
          nodes {
            databaseId
            name
            company
            organization {
              databaseId
            }
          }
        }
      }
    }
  }
`

// Requests the information needed to populate UserIdentity and determine whether role picker needs to be loaded.
// This queries for specifically two of each partner to answer definitely if the user only has one role.
// TODO: When we persist the user's last role we can try to grab that from this query too.
const userInfoQuery = async (client: ApolloClient<NormalizedCacheObject>) => {
  return client
    .query({
      errorPolicy: 'all',
      query: QUERY
    })
    .then((result: any): UserInfoResponse => {
      const {
        databaseId,
        firstName,
        lastName,
        publishers,
        vendors,
        affiliates,
        admin,
        email
      } = result.data.viewer
      return {
        id: databaseId,
        admin,
        fullName: `${firstName} ${lastName}`,
        email,
        publishers: formatPublishers(publishers),
        vendors: formatVendors(vendors),
        affiliates: formatAffiliates(affiliates)
      }
    })
}

const formatPublishers = (connection: any): UserRole[] =>
  formatRole('PUBLISHER', connection)

const formatVendors = (connection: any): UserRole[] =>
  formatRole('VENDOR', connection)

const formatAffiliates = (connection: any): UserRole[] =>
  formatRole('AFFILIATE', connection)

const formatRole = (type: RoleType, connection: any): UserRole[] => {
  const result: UserRole[] = []

  connection.nodes.forEach((node: any) => {
    if (!node || !node.organization) return

    result.push({
      id: node.databaseId,
      name: node.name,
      subname: type === 'PUBLISHER' ? node.hostname : node.company,
      organizationId: node.organization.databaseId,
      type
    })
  })

  return result
}

export default userInfoQuery
